// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** >>>>>>>>>>>>>>>>> content review styles <<<<<<<<<<<<<<<<<<<<<**/
.conversation-basic-info-section {
	display: flex;
	gap: 24px;
	align-items: center;
	padding: 12px 16px;
	background-color: white;
	border-radius: 4px;
	margin-bottom: 16px;
}

.conversation-basic-info-section .conversation-basic-info-piece {
	display: flex;
	flex-direction: column;
	gap: 6px;
	flex: 1 1;
	flex-shrink: 0;
}

.conversation-basic-info-section .conversation-basic-info-piece .conversation-basic-info-title {
	color: #707070;
	font-family: 'Segoe UI';
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
}

.conversation-basic-info-section .conversation-basic-info-piece .conversation-basic-info-value {
	color: #3b3b3b;
	font-family: 'Segoe UI';
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
}

.conversation-review-section {
	display: flex;
	flex: 1 1;
	gap: 16px;
}

/** >>>>>>>>>>>>>>>>> chat list styles <<<<<<<<<<<<<<<<<<<<<**/

.chat-list-container {
	display: block;
	flex-direction: column;
	flex: 1 1;
}
.review-selected {
	border: 1px solid #47e1e7;
}

.content-review-section-header {
	display: flex;
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
	background-color: #e0f6f8;
	padding: 11px 16px;
	color: black;
	font-family: 'Segoe UI';
	font-size: 14px;
	font-style: normal;
	font-weight: 700;
}

.chat-list-container .chat-list-content {
	display: flex;
	flex: 1 1;
	overflow-y: scroll;
	flex-direction: column;
	gap: 8px;
	height: calc(100vh - 340px);
}

.chat-message-container {
	display: flex;
	flex-direction: column;
	gap: 16px;
	background-color: white;
	padding: 16px;
	position: relative;
}

.chat-message {
	display: flex;
	flex-direction: row;
}

.question {
	justify-content: end;
}

.chat-message .content {
	color: black;
	font-family: 'Segoe UI';
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	margin: auto 8px;
	max-width: 80%;
}

.chat-message .content-group {
	display: flex;
	flex-direction: column;
	flex: 1 1;
	align-items: flex-end;
}

.chat-message .image-wrapper {
	padding: 8px;
}

.question .content {
	color: #3b3b3b;
}

.message-icon-container {
	position: relative;
}

.message-icon-container .review-icon {
	position: absolute;
	top: 24px;
	right: 0px;
}

.source {
	flex-direction: column;
}

.file-source-header {
	display: flex;
	align-items: center;
	font-family: 'Segoe UI';
	font-size: 12px;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
	gap: 12px;
}

.file-link {
	padding-left: 32px;
	color: #005faa;
	font-family: 'Segoe UI';
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 22px;
	text-decoration: underline;
	cursor: pointer;
}

.chat-message-status-icon {
	font-family: 'Segoe UI';
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	text-align: center;
	padding: 4px 0px;
	border-radius: 4px;
	display: inline-block;
	width: 88px;
	height: 28px;
	position: absolute;
	top: 16px;
	left: 16px;
}

/** >>>>>>>>>>>>>>>>> markdown styles <<<<<<<<<<<<<<<<<<<<<**/

.chat-message .markdown-container p {
	margin-bottom: 8px;
}

.chat-message .markdown-container h1,
h2,
h3,
h4,
h5,
h6 {
	font-family: 'SegoeUI Bold', sans-serif !important;
	font-weight: 600 !important;
	margin-bottom: 8px;
}

.chat-message .markdown-container li {
	margin-bottom: 4px;
}

.chat-message .markdown-container li:last-child {
	margin-bottom: 0px;
}

.chat-message .markdown-container ol {
	list-style-type: decimal;
	margin-inline: 0px;
	margin-bottom: 20px;
	margin-top: 0px;
	padding-left: 32px;
}

.chat-message .markdown-container ul {
	list-style-type: decimal;
	margin-inline: 0px;
	margin-bottom: 20px;
	margin-top: 0px;
	padding-left: 32px;
}

.chat-message .markdown-container > :last-child {
	margin-bottom: 0px;
}

.chat-message .markdown-container th,
.chat-message .markdown-container td {
	border: 2px solid #d1d5dc;
	padding-inline: 16px;
	padding-block: 8px;
}

.chat-message .markdown-container table {
	margin-bottom: 16px;
}

.chat-message .markdown-container img {
	margin-top: 8px;
	max-width: 160x;
	max-height: 160px;
}

/** >>>>>>>>>>>>>>>>> chat review form styles <<<<<<<<<<<<<<<<<<<<<**/

.chat-review-form-container {
	width: 376px;
}

.chat-review-form-container .ant-form-item:not(:first-child) {
	margin-bottom: 0px !important;
}

.chat-review-form-container .ant-form-item:first-child {
	margin-bottom: 8px !important;
}

.chat-review-form-container .ant-form-item-row {
	padding: 16px;
	background-color: white;
}

.chat-review-form-container .ant-form-item .ant-form-item-label > label {
	color: #3b3b3b !important;
	font-family: 'Segoe UI';
	font-size: 14px !important;
	font-style: normal !important;
	font-weight: 400 !important;
	padding-left: 0px !important;
}

.chat-review-form-container .ant-form-item-control .ant-radio-wrapper span.ant-radio + * {
	color: #3b3b3b;
	font-family: 'Segoe UI';
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
}
.chat-review-form-container .ant-form-item-control .ant-radio-wrapper:first-child {
	margin-right: 16px;
}

.chat-review-form-container .ant-form-item-horizontal .ant-form-item-control {
	display: flex;
	align-items: end;
}

.submit-button-container {
	display: flex;
	justify-content: flex-end;
	padding: 28px 16px 12px 16px;
	background-color: white;
}

.no-more-option-placeholder {
	background-color: white;
	color: #b5b5b5;
	font-family: 'Segoe UI';
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	padding: 16px;
	height: 56px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/guardrail/content-detail/index.css"],"names":[],"mappings":"AAAA,mEAAmE;AACnE;CACC,aAAa;CACb,SAAS;CACT,mBAAmB;CACnB,kBAAkB;CAClB,uBAAuB;CACvB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,QAAQ;CACR,SAAO;CACP,cAAc;AACf;;AAEA;CACC,cAAc;CACd,uBAAuB;CACvB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,uBAAuB;CACvB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,SAAO;CACP,SAAS;AACV;;AAEA,8DAA8D;;AAE9D;CACC,cAAc;CACd,sBAAsB;CACtB,SAAO;AACR;AACA;CACC,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,2BAA2B;CAC3B,4BAA4B;CAC5B,yBAAyB;CACzB,kBAAkB;CAClB,YAAY;CACZ,uBAAuB;CACvB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,SAAO;CACP,kBAAkB;CAClB,sBAAsB;CACtB,QAAQ;CACR,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,uBAAuB;CACvB,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,YAAY;CACZ,uBAAuB;CACvB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAO;CACP,qBAAqB;AACtB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,UAAU;AACX;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,uBAAuB;CACvB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB;CACjB,0BAA0B;CAC1B,eAAe;AAChB;;AAEA;CACC,uBAAuB;CACvB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;CAClB,qBAAqB;CACrB,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,SAAS;CACT,UAAU;AACX;;AAEA,6DAA6D;;AAE7D;CACC,kBAAkB;AACnB;;AAEA;;;;;;CAMC,kDAAkD;CAClD,2BAA2B;CAC3B,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,wBAAwB;CACxB,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,wBAAwB;CACxB,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;CAEC,yBAAyB;CACzB,oBAAoB;CACpB,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,eAAe;CACf,iBAAiB;AAClB;;AAEA,qEAAqE;;AAErE;CACC,YAAY;AACb;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,aAAa;CACb,uBAAuB;AACxB;;AAEA;CACC,yBAAyB;CACzB,uBAAuB;CACvB,0BAA0B;CAC1B,6BAA6B;CAC7B,2BAA2B;CAC3B,4BAA4B;AAC7B;;AAEA;CACC,cAAc;CACd,uBAAuB;CACvB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;AACjB;AACA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,yBAAyB;CACzB,4BAA4B;CAC5B,uBAAuB;AACxB;;AAEA;CACC,uBAAuB;CACvB,cAAc;CACd,uBAAuB;CACvB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,aAAa;CACb,YAAY;AACb","sourcesContent":["/** >>>>>>>>>>>>>>>>> content review styles <<<<<<<<<<<<<<<<<<<<<**/\n.conversation-basic-info-section {\n\tdisplay: flex;\n\tgap: 24px;\n\talign-items: center;\n\tpadding: 12px 16px;\n\tbackground-color: white;\n\tborder-radius: 4px;\n\tmargin-bottom: 16px;\n}\n\n.conversation-basic-info-section .conversation-basic-info-piece {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 6px;\n\tflex: 1;\n\tflex-shrink: 0;\n}\n\n.conversation-basic-info-section .conversation-basic-info-piece .conversation-basic-info-title {\n\tcolor: #707070;\n\tfont-family: 'Segoe UI';\n\tfont-size: 12px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: normal;\n}\n\n.conversation-basic-info-section .conversation-basic-info-piece .conversation-basic-info-value {\n\tcolor: #3b3b3b;\n\tfont-family: 'Segoe UI';\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: normal;\n}\n\n.conversation-review-section {\n\tdisplay: flex;\n\tflex: 1;\n\tgap: 16px;\n}\n\n/** >>>>>>>>>>>>>>>>> chat list styles <<<<<<<<<<<<<<<<<<<<<**/\n\n.chat-list-container {\n\tdisplay: block;\n\tflex-direction: column;\n\tflex: 1;\n}\n.review-selected {\n\tborder: 1px solid #47e1e7;\n}\n\n.content-review-section-header {\n\tdisplay: flex;\n\tborder-top-left-radius: 4px;\n\tborder-top-right-radius: 4px;\n\tbackground-color: #e0f6f8;\n\tpadding: 11px 16px;\n\tcolor: black;\n\tfont-family: 'Segoe UI';\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 700;\n}\n\n.chat-list-container .chat-list-content {\n\tdisplay: flex;\n\tflex: 1;\n\toverflow-y: scroll;\n\tflex-direction: column;\n\tgap: 8px;\n\theight: calc(100vh - 340px);\n}\n\n.chat-message-container {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 16px;\n\tbackground-color: white;\n\tpadding: 16px;\n\tposition: relative;\n}\n\n.chat-message {\n\tdisplay: flex;\n\tflex-direction: row;\n}\n\n.question {\n\tjustify-content: end;\n}\n\n.chat-message .content {\n\tcolor: black;\n\tfont-family: 'Segoe UI';\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: normal;\n\tmargin: auto 8px;\n\tmax-width: 80%;\n}\n\n.chat-message .content-group {\n\tdisplay: flex;\n\tflex-direction: column;\n\tflex: 1;\n\talign-items: flex-end;\n}\n\n.chat-message .image-wrapper {\n\tpadding: 8px;\n}\n\n.question .content {\n\tcolor: #3b3b3b;\n}\n\n.message-icon-container {\n\tposition: relative;\n}\n\n.message-icon-container .review-icon {\n\tposition: absolute;\n\ttop: 24px;\n\tright: 0px;\n}\n\n.source {\n\tflex-direction: column;\n}\n\n.file-source-header {\n\tdisplay: flex;\n\talign-items: center;\n\tfont-family: 'Segoe UI';\n\tfont-size: 12px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: normal;\n\tgap: 12px;\n}\n\n.file-link {\n\tpadding-left: 32px;\n\tcolor: #005faa;\n\tfont-family: 'Segoe UI';\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 22px;\n\ttext-decoration: underline;\n\tcursor: pointer;\n}\n\n.chat-message-status-icon {\n\tfont-family: 'Segoe UI';\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: normal;\n\ttext-align: center;\n\tpadding: 4px 0px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n\twidth: 88px;\n\theight: 28px;\n\tposition: absolute;\n\ttop: 16px;\n\tleft: 16px;\n}\n\n/** >>>>>>>>>>>>>>>>> markdown styles <<<<<<<<<<<<<<<<<<<<<**/\n\n.chat-message .markdown-container p {\n\tmargin-bottom: 8px;\n}\n\n.chat-message .markdown-container h1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n\tfont-family: 'SegoeUI Bold', sans-serif !important;\n\tfont-weight: 600 !important;\n\tmargin-bottom: 8px;\n}\n\n.chat-message .markdown-container li {\n\tmargin-bottom: 4px;\n}\n\n.chat-message .markdown-container li:last-child {\n\tmargin-bottom: 0px;\n}\n\n.chat-message .markdown-container ol {\n\tlist-style-type: decimal;\n\tmargin-inline: 0px;\n\tmargin-bottom: 20px;\n\tmargin-top: 0px;\n\tpadding-left: 32px;\n}\n\n.chat-message .markdown-container ul {\n\tlist-style-type: decimal;\n\tmargin-inline: 0px;\n\tmargin-bottom: 20px;\n\tmargin-top: 0px;\n\tpadding-left: 32px;\n}\n\n.chat-message .markdown-container > :last-child {\n\tmargin-bottom: 0px;\n}\n\n.chat-message .markdown-container th,\n.chat-message .markdown-container td {\n\tborder: 2px solid #d1d5dc;\n\tpadding-inline: 16px;\n\tpadding-block: 8px;\n}\n\n.chat-message .markdown-container table {\n\tmargin-bottom: 16px;\n}\n\n.chat-message .markdown-container img {\n\tmargin-top: 8px;\n\tmax-width: 160x;\n\tmax-height: 160px;\n}\n\n/** >>>>>>>>>>>>>>>>> chat review form styles <<<<<<<<<<<<<<<<<<<<<**/\n\n.chat-review-form-container {\n\twidth: 376px;\n}\n\n.chat-review-form-container .ant-form-item:not(:first-child) {\n\tmargin-bottom: 0px !important;\n}\n\n.chat-review-form-container .ant-form-item:first-child {\n\tmargin-bottom: 8px !important;\n}\n\n.chat-review-form-container .ant-form-item-row {\n\tpadding: 16px;\n\tbackground-color: white;\n}\n\n.chat-review-form-container .ant-form-item .ant-form-item-label > label {\n\tcolor: #3b3b3b !important;\n\tfont-family: 'Segoe UI';\n\tfont-size: 14px !important;\n\tfont-style: normal !important;\n\tfont-weight: 400 !important;\n\tpadding-left: 0px !important;\n}\n\n.chat-review-form-container .ant-form-item-control .ant-radio-wrapper span.ant-radio + * {\n\tcolor: #3b3b3b;\n\tfont-family: 'Segoe UI';\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 400;\n}\n.chat-review-form-container .ant-form-item-control .ant-radio-wrapper:first-child {\n\tmargin-right: 16px;\n}\n\n.chat-review-form-container .ant-form-item-horizontal .ant-form-item-control {\n\tdisplay: flex;\n\talign-items: end;\n}\n\n.submit-button-container {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tpadding: 28px 16px 12px 16px;\n\tbackground-color: white;\n}\n\n.no-more-option-placeholder {\n\tbackground-color: white;\n\tcolor: #b5b5b5;\n\tfont-family: 'Segoe UI';\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tpadding: 16px;\n\theight: 56px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
